import { render, staticRenderFns } from "./spaceflight.vue?vue&type=template&id=3f7ff7a4&scoped=true"
import script from "./spaceflight.vue?vue&type=script&lang=js"
export * from "./spaceflight.vue?vue&type=script&lang=js"
import style0 from "./spaceflight.vue?vue&type=style&index=0&id=3f7ff7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ff7a4",
  null
  
)

export default component.exports